import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useWishlistStore = create(
  persist(
    (set, get) => ({
      items: [],
      
      // Add item to wishlist
      addItem: (product) => {
        const items = get().items;
        const exists = items.find(item => item.id === product.id);
        if (!exists) {
          set({ items: [...items, {
            id: product.id,
            name: product.name,
            slug: product.slug,
            price: product.price,
            discount_price: product.discount_price,
            images: product.images,
            in_stock: product.in_stock
          }] });
        }
      },
      
      // Remove item from wishlist
      removeItem: (productId) => {
        set({ items: get().items.filter(item => item.id !== productId) });
      },
      
      // Toggle item in wishlist
      toggleItem: (product) => {
        const items = get().items;
        const exists = items.find(item => item.id === product.id);
        if (exists) {
          set({ items: items.filter(item => item.id !== product.id) });
          return false; // removed
        } else {
          set({ items: [...items, {
            id: product.id,
            name: product.name,
            slug: product.slug,
            price: product.price,
            discount_price: product.discount_price,
            images: product.images,
            in_stock: product.in_stock
          }] });
          return true; // added
        }
      },
      
      // Check if item is in wishlist
      isInWishlist: (productId) => {
        return get().items.some(item => item.id === productId);
      },
      
      // Get wishlist count
      getCount: () => {
        return get().items.length;
      },
      
      // Clear wishlist
      clearWishlist: () => {
        set({ items: [] });
      }
    }),
    {
      name: 'jat-wishlist',
    }
  )
);

export default useWishlistStore;
